const sidebars = {
  namespaced: true,
  state: () => ({
    errorForm: false,
    idForReturnPatronForm: null,
    idForPatronForm: null,
    additionalDataForPatronForm: null,
    donatFormOpen: false,
    registrationOpen: false,
    registrationWithMir: false,
    getPatronMasterpiece: null
  }),
  mutations: {
    openErrorForm (state) {
      state.errorForm = true
    },
    closeErrorForm (state) {
      state.errorForm = false
    },
    changeIdForReturnPatronForm(state, value = null) {
      state.idForReturnPatronForm = value ? value.id : null;
      state.additionalDataForPatronForm = value ? value.additional : null;
    },
    changeIdForPatronForm(state, value = null) {
      state.idForPatronForm = value ? value.id : null;
      state.additionalDataForPatronForm = value ? value.additional : null;
    },
    changeAdditionalDataForPatronForm(state, value = null) {
      state.additionalDataForPatronForm = {...state.additionalDataForPatronForm, ...value}
    },
    closeDonatForm(state) {
      state.donatFormOpen = false;
    },
    openDonatForm(state) {
      state.donatFormOpen = true;
    },
    changeRegistrationPopup (state, value = false) {
      state.registrationOpen = value;
    },
    changeRegistrationWithMir (state, value = false) {
      state.registrationWithMir = value;
    },
    changeGetPatronMasterpiece (state, value = null) {
      state.getPatronMasterpiece = value;
    },
    openGetPatronMasterpieceStepTwo (state) {
      state.getPatronMasterpiece = {
        ...state.getPatronMasterpiece,
        showGiftForm: true
      };
    },
  },
  getters: {
    getErrorForm: (state) => {
      return state.errorForm
    },
    getIdForReturnPatronForm: (state) => {
      return state.idForReturnPatronForm
    },
    getIdForPatronForm: (state) => {
      return state.idForPatronForm
    },
    getAdditionalDataForPatronForm: (state) => {
      return state.additionalDataForPatronForm
    },
    getDonatFormOpen: (state) => {
      return state.donatFormOpen
    },
    getRegistrationOpen: (state) => {
      return state.registrationOpen
    },
    getRegistrationWithMir: (state) => {
      return state.registrationWithMir
    },
    getPatronMasterpiece: (state) => {
      return state.getPatronMasterpiece
    }
  }
}
export default sidebars
